import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useSettings } from "@/contexts/SettingsContext";
import { initTracking, isTrackingReady, trackPageView } from "@/lib/seo";

/** Loads GA4 / Ads / Meta Pixel once, then fires a pageview on every SPA navigation. */
const SiteTracking = () => {
    const { settings } = useSettings();
    const location = useLocation();
    const lastPath = useRef("");

    useEffect(() => {
        if (settings) initTracking(settings);
    }, [settings]);

    useEffect(() => {
        if (!settings || !isTrackingReady()) return;
        const key = `${location.pathname}${location.search}`;
        if (key === lastPath.current) return;
        lastPath.current = key;
        trackPageView(location.pathname, location.search);
    }, [settings, location.pathname, location.search]);

    return null;
};

export default SiteTracking;
